import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "isInvalid", "id", "className", "defaultValue", "locale", "mode", "dateFormat", "size", "onBlur", "onChange", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { StyledDateInput, StyledDateInputStyles } from './DateInput.styles';
import Icon from '../Icon';
import dayjs from 'dayjs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DateInput = forwardRef(function (_ref, ref) {
  var _cx, _ref2;

  var _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isInvalid = _ref.isInvalid,
      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
      id = _ref.id,
      customClassName = _ref.className,
      defaultValue = _ref.defaultValue,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en-gb' : _ref$locale,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      dateFormat = _ref.dateFormat,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-dateinput"), true), _defineProperty(_cx, "".concat(prefix, "-dateinput--disabled"), isDisabled), _defineProperty(_cx, "".concat(prefix, "-dateinput--invalid"), isInvalid), _defineProperty(_cx, customClassName, !!customClassName), _cx));

  var rightElement = _jsx(Icon, {
    icon: "calendar",
    color: isInvalid ? 'var(--dentsu-color-r600)' : 'var(--dentsu-color-n650)'
  });

  function getDateFormatter(format) {
    return {
      formatDate: function formatDate(date, locale) {
        return dayjs(date).locale(locale).format(format);
      },
      parseDate: function parseDate(str, locale) {
        return dayjs(str, format).locale(locale).toDate();
      },
      placeholder: format
    };
  }

  var onBlurDate = (_ref2 = value || defaultValue) !== null && _ref2 !== void 0 ? _ref2 : null;

  function onChangeHandler(date, secondArgument) {
    onChange && onChange(date, secondArgument);
    onBlurDate = date;
  }

  function onBlurHandler() {
    onBlur(onBlurDate);
  }

  return _jsxs(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: [_jsx(StyledDateInputStyles, {}), _jsx(StyledDateInput, _objectSpread(_objectSpread({
      "aria-disabled": isDisabled,
      "aria-invalid": isInvalid,
      disabled: isDisabled,
      id: id,
      ref: ref,
      className: className,
      defaultValue: defaultValue,
      inputProps: _objectSpread({
        rightElement: rightElement
      }, onBlur && {
        onBlur: function onBlur(event) {
          event.persist();
          setTimeout(function () {
            onBlurHandler();
          }, 100);
        }
      }),
      locale: locale,
      onChange: function onChange(date, secondArgument) {
        onChangeHandler(date, secondArgument);
      },
      value: value
    }, dateFormat && getDateFormatter(dateFormat)), rest))]
  });
});
export default DateInput;